export default [
    {
      path: '/facility',
      name: 'facility-read',
      component: () => import('@/views/event/facilities/FacilityList.vue'),
      meta: {
        resource: 'Facilities',
        action: 'read',
      },
    },
    {
        path: '/facility-icon',
        name: 'facility-icon-read',
        component: () => import('@/views/event/facilities/FacilityIconList.vue'),
        meta: {
          resource: 'Facility Icons',
          action: 'read',
        },
    },
  ]